import { privateApi } from '@/config/axios.config';

const API_BASE = '/condominium/administration';

export interface Administration {
  id: string;
  title: string;
  type: 'meeting' | 'document' | 'procedure' | 'contract';
  status: 'active' | 'inactive' | 'pending' | 'completed';
  description?: string;
  date?: string;
  createdAt: string;
  updatedAt: string;
}

export interface AdministrationCreateDTO {
  title: string;
  type: 'meeting' | 'document' | 'procedure' | 'contract';
  description?: string;
  date?: string;
}

export interface AdministrationUpdateDTO extends Partial<AdministrationCreateDTO> {
  id: string;
  status?: 'active' | 'inactive' | 'pending' | 'completed';
}

export interface AdministrationFilters {
  type?: string;
  status?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export interface AdministrationStats {
  total: number;
  meetings: number;
  documents: number;
  procedures: number;
  contracts: number;
  pending: number;
  completed: number;
}

export const administrationApiService = {
  // Obtener todos los registros administrativos con filtros
  async getAdministrations(filters: AdministrationFilters = {}): Promise<{
    administrations: Administration[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  }> {
    const params = new URLSearchParams();

    if (filters.type) params.append('type', filters.type);
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());

    const response = await privateApi.get(`${API_BASE}?${params.toString()}`);
    return response.data?.data || response.data;
  },

  // Obtener un registro por ID
  async getAdministrationById(id: string): Promise<Administration> {
    const response = await privateApi.get(`${API_BASE}/${id}`);
    return response.data?.data || response.data;
  },

  // Crear un nuevo registro
  async createAdministration(data: AdministrationCreateDTO): Promise<Administration> {
    const response = await privateApi.post(API_BASE, data);
    return response.data?.data || response.data;
  },

  // Actualizar un registro
  async updateAdministration(
    id: string,
    data: AdministrationUpdateDTO
  ): Promise<Administration> {
    const response = await privateApi.patch(`${API_BASE}/${id}`, data);
    return response.data?.data || response.data;
  },

  // Eliminar un registro
  async deleteAdministration(id: string): Promise<void> {
    await privateApi.delete(`${API_BASE}/${id}`);
  },

  // Cambiar estado de un registro (toggle)
  async toggleAdministrationStatus(id: string): Promise<Administration> {
    const response = await privateApi.patch(`${API_BASE}/${id}/toggle-status`);
    return response.data?.data || response.data;
  },

  // Obtener estadísticas
  async getAdministrationStats(): Promise<AdministrationStats> {
    const response = await privateApi.get(`${API_BASE}/stats`);
    return response.data?.data || response.data;
  },
};












